import { Joi, actionCreator, objectSchemaOf } from '../helpers';
import { DIALOGUE_INPUT } from './topics';

export const FACE = 'DIALOGUE/FACE';

export interface IFacePayload {
  conversationId: string;
  faceId: string;
}

export const updateFacePayloadSchema = objectSchemaOf<IFacePayload>({
  conversationId: Joi.string().required(),
  faceId: Joi.string().required(),
});

export interface IFaceAction {
  type: typeof FACE;
  payload: IFacePayload;
}

export const faceActionSchema = objectSchemaOf<IFaceAction>({
  type: Joi.string().required().valid(FACE),
  payload: updateFacePayloadSchema.required(),
});

export const face = actionCreator({
  schema: faceActionSchema,
  topic: DIALOGUE_INPUT,
  type: FACE,
});
